import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import Router from "vue-router";
import VueResource from "vue-resource";
import firebase from "firebase";
import Vuetify from "vuetify";
import VueI18n from "vue-i18n";
import * as VueGoogleMaps from "vue2-google-maps";
import VueAnalytics from "vue-analytics";
import {firebaseConfig} from "../firebase.config";
import $ from "jquery";

import {RouterManager} from "./router";
import {StoreManager} from "./store";
import {LanguageManager} from "./languages/languages";
import {ConfigService} from "./helpers/services/configService";
import {routeInterceptorLoader} from "./helpers/interceptors/routeInterceptor";
import {requestInterceptorLoader} from "./helpers/interceptors/requestInterceptor";

import "style-loader!css-loader!../node_modules/vuetify/dist/vuetify.min.css";
import "style-loader!css-loader!../node_modules/fullcalendar/dist/fullcalendar.css";
import "./style/theme.styl";
import "./style/commons.styl";

import "./helpers/services/configService";
import "./helpers/interceptors/routeInterceptor";

import "./components/views/app/app";
import "./components/views/home/home";

import "./components/plain/avatar/avatar";
import "./components/plain/sidebar/sidebar";
import "./components/plain/toolbar/toolbar";
import "./components/plain/loginCard/loginCard";
import "./components/plain/userStatusBlock/userStatusBlock";
import "./components/plain/globalNotification/globalNotification";
import "./loader";

import "../index.html";

import {eventBus, signalNames} from "./bus";
import {VueLogger} from "./helpers/loggerPlugin";
import {session} from "./stores/session";
import {AuthMode} from "./models/authMode";
// import {sessionActions} from "./storeModules/session/sessionActions";

window["jQuery"] = window["$"] = $;
firebase.initializeApp(firebaseConfig());
moment.locale("it");

Vue.use(Vuex);
Vue.use(Router);
Vue.use(Vuetify);
Vue.use(VueI18n);
Vue.use(VueLogger);
Vue.use(VueResource);
Vue.use(VueGoogleMaps, { load: { key: ConfigService.googleMapsKey, v: "3" } });

let routerInstance = RouterManager.instance = new RouterManager();
let storeInstance = StoreManager.instance = new StoreManager();
let languageInstance = LanguageManager.instance = new LanguageManager();

Vue.use(VueAnalytics, {id: ConfigService.googleAnalyticsId, Router});
Vue.http.options.root = ConfigService.apiEndpoint;

requestInterceptorLoader.load();

let isPlatformStarting = true;
let onStartupTasks = () => {
  if (isPlatformStarting) {
    routeInterceptorLoader.load();

    const app = new Vue({
      el: "#app",
      store: storeInstance.store,
      router: routerInstance.router,
      i18n: languageInstance.i18n
    });

    // enabling hot reloading for language files
    if (module.hot) {
      module.hot.accept(["./languages/en", "./languages/it"], () => {
        app.$i18n.setLocaleMessage("en", require("./languages/en").default);
        app.$i18n.setLocaleMessage("it", require("./languages/it").default);
      });
    }
    isPlatformStarting = false;
  }
};

session.dispatchAutoLogin(StoreManager.instance.store, {}).then(() => {
  onStartupTasks();
}).catch(() => {
  onStartupTasks();
});


Vue.config.devtools = true;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app.ts